'use client';

import { useCallback, useRef } from 'react';

import { useStaticContext } from '~/utilities/context/static/StaticContext';
import { useEffectOnce } from '~/utilities/hooks';

declare global {
  interface Window {
    Kameleoon?: {
      Analyst?: {
        load: () => void;
      };
    };
  }
}

export const KameleoonScript = () => {
  const {
    configuration: { kameleoonEnabled, kameleoonSiteCode },
  } = useStaticContext();

  const isFirstRender = useRef(true);

  const loadEngine = useCallback(() => {
    if (document.getElementById('kameleoon-engine') || !kameleoonSiteCode || !kameleoonEnabled) {
      return;
    }

    const script = document.createElement('script');

    script.src = `https://${kameleoonSiteCode}.kameleoon.io/engine.js`;
    script.async = true;
    script.id = 'kameleoon-engine';
    document.body.appendChild(script);
  }, [kameleoonEnabled, kameleoonSiteCode]);

  useEffectOnce(() => {
    loadEngine();

    if (isFirstRender.current) {
      isFirstRender.current = false;

      return;
    }

    window.Kameleoon?.Analyst?.load();
  });

  return null;
};
